;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import PropTypes from 'prop-types';

import Text from 'components/ui/Text';

import styles from './CardNoResults.module.scss';

const CardNoResults = ({ search }) => {
    return (
        <div className={styles.root}>
            <Text className={styles.text} as="h3" baseTheme="headingLarge">
                Sorry, we couldn’t find any results{' '}
                {search ? (
                    <>
                        for&nbsp;<q>{search}</q>
                    </>
                ) : null}
            </Text>
        </div>
    );
};

CardNoResults.propTypes = {
    search: PropTypes.string,
};

export default CardNoResults;
